module.exports = __webpack_public_path__ + "b6214cb831273513cc74f07a2ea18b48.png";